import {useEffect, useState} from "react";
import kapi from "../api/kratos"


const Authenticator = () => {

    const [flow, setFlow] = useState(null);
    const [totp, setTotp] = useState("")

    const PageLoad = () => {
        const params = new URLSearchParams(window.location.search);
        const flowId = params.get('flow');

        if (!flowId) {
            let response = kapi.init_settings();
            response.then(response => {
                setFlow(response.data)
            }).catch(err => console.log(err))
        } else {
            let response = kapi.get_settings(flowId);
            response.then(response => {
                setFlow(response.data);
            }).catch();
        }
    }

    useEffect(() => {
        PageLoad()
    }, []);


    return (
        <div className="login-page-container">
            <div className="login-container">
                <div className="login-welcome-container col">
                    <div className="login-welcome-title">
                        Enable 2FA
                    </div>
                    <div className="login-welcome-subtitle">
                        The CCMI Admin Portal requires two-factor authentication
                    </div>
                    <div className="login-welcome-subtitle">
                        To enable 2FA, scan the QR code with Google Authenticator, then enter your OTP below. If
                        you are unable to scan the QR code, you can use the setup key instead
                    </div>
                    <form action={flow && flow.ui.action} method="POST">
                        <input name="csrf_token" type="hidden"
                               value={flow && flow.ui.nodes.find(n => n.attributes.name === 'csrf_token')?.attributes.value}
                        />
                        <img src={flow && flow.ui.nodes.find(n => n.attributes.id === 'totp_qr')?.attributes.src}
                             className="settings-mfa-form-image"
                        />
                        <div className="bold">
                            {flow && flow.ui.nodes.find(n => n.attributes.id === 'totp_secret_key')?.attributes.text.text}
                        </div>
                        <div className="messages">
                            {flow && flow.ui.nodes.find(n => n.attributes.name === 'totp_code').messages.map((message, idx) => {
                                return <div key={idx}>{message.text}</div>
                            })}
                        </div>
                        <div className="field-input-entry">
                            <input className="settings-mfa-totp-input settings-input" name="totp_code" value={totp}
                                   maxLength={6} onChange={ev => setTotp(ev.target.value.trim())}/>
                        </div>
                        <button className="settings-button small-button" name="method" type="submit" value="totp">
                            Submit OTP
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}


export default Authenticator